import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-solutions',
  templateUrl: './business-solutions.component.html',
  styleUrls: ['./business-solutions.component.css']
})
export class BusinessSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
